import { render, staticRenderFns } from "./ChannelBadge.vue?vue&type=template&id=4413333e&"
import script from "./ChannelBadge.vue?vue&type=script&lang=js&"
export * from "./ChannelBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports